import { z } from "zod";
const date = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((s) => {
    const n = new Date(s + "T00:00:00Z");
    return Number.isFinite(n.getTime()) && n.toISOString().slice(0, 10) === s;
}, "Некорректная дата");
export const pressOneAnalyticsQuerySchema = z
    .object({
    from: date,
    to: date,
    includeTests: z.enum(["true", "false"]).default("false"),
    sourceId: z.coerce.number().int().positive().optional(),
})
    .refine((p) => p.to >= p.from && (Date.parse(p.to) - Date.parse(p.from)) / 86400000 < 93, "Период должен быть от 1 до 93 дней");
//# sourceMappingURL=press-one-analytics.dto.js.map